/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyMenuItemSupplyModel as DigiworkMaitreDPosDtoMenuCompanyMenuItemSupplyModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/company-menu-item-supply-model';

export interface CreateMenuItem$Params {
      body?: {
'Name'?: string;
'Description'?: string;
'CompanyId'?: string;
'CompanyMenuCategoryId'?: string;
'LanguageId'?: number;
'Price'?: number;
'MenuItemTypeId'?: number;
'ImageFile'?: Blob;
'Supplies'?: Array<DigiworkMaitreDPosDtoMenuCompanyMenuItemSupplyModel>;
'TaxRateId'?: string;
'SubVenueIds'?: Array<string>;
}
}

export function createMenuItem(http: HttpClient, rootUrl: string, params?: CreateMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createMenuItem.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createMenuItem.PATH = '/api/gmn/Menu/createmenuitem';
